var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":"","hide-details":"hideDetails","label":_vm.label,"prepend-inner-icon":"mdi-magnify","clearable":_vm.clearable},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }